import { Controller } from "@hotwired/stimulus"

export default class OrderSummaryController extends Controller {
  static targets = ["paymentMethod", "submitBtn", "form", "qrPromptpay"]
  static values = {
    selectedPayment: String,
    formUrl: String
  }

  connect() {
    this.changePaymentMethod(this.selectedPaymentValue)
  } 

  handlePaymentMethodChange(event) {
    event.preventDefault()
    const methodPanel = event.currentTarget
    const methodInput = methodPanel.querySelector("input[type='radio']")
    const method = methodInput.value

    this.changePaymentMethod(method)
  }

  changePaymentMethod(method) {
    this.selectedPaymentValue = method

    this.removeAllHightlightBorder()
    this.addHighlightBorder()
    this.checkedSelectedMethodRadioBtn()
    this.setFormUrl()
    this.putSubmitBtn()
  }

  methodPanel() {
    let method = this.selectedPaymentValue
    return this[`${method}Target`]
  }

  removeAllHightlightBorder() {
    this.paymentMethodTargets.forEach(method => {
      method.classList.remove("highlight")
    })
  }

  addHighlightBorder() {
    let panel = this.methodPanel()
    panel.classList.add("highlight")
  }

  checkedSelectedMethodRadioBtn() {
    let radioBtn = this.methodPanel().querySelector("input[type='radio']")
    radioBtn.checked = true
  }

  // action ของฟอร์มมาจาก ERB (form_with url:) ไม่แก้จากฝั่ง JS
  // Rails ผูก CSRF token กับ action ที่ render มา (per_form_csrf_tokens) — เขียนทับ action
  // ทำให้ token ใช้ไม่ได้ ทุกการกดจ่ายเงินเด้ง InvalidAuthenticityToken
  // ถ้าจะเพิ่มวิธีชำระเงินวิธีที่สอง ต้องแยกเป็นคนละ form ไม่ใช่สลับ action ของ form เดียว
  setFormUrl() {
    this.formUrlValue = this.formTarget.action
  }

  putSubmitBtn() {
    let selectedMethodPanel = this.methodPanel()
    let btnText = getSubmitBtnText(this.selectedPaymentValue)
    let btnHTML = `
    <input type="submit" value="${btnText}" class="bg-btn-orange inline-block w-full py-2 text-center text-white text-lg font-semibold rounded-lg cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed mt-4" data-order-summary-target="submitBtn" data-action="order-summary#submitForm">
    `

    if(this.hasSubmitBtnTarget) {
      this.submitBtnTarget.remove()
    }
    selectedMethodPanel.insertAdjacentHTML('beforeend', btnHTML)

    function getSubmitBtnText(method) {
      switch (method) {
        case "qrPromptpay":  return document.querySelector("label[for=payment-method-qr-promptpay] span")?.textContent || "" // ป้ายเดียวกับหัวตัวเลือก (ตามภาษาของหน้า)
      }
    }
  }

  submitForm() {
    this.formTarget.submit()
  }
}
